export enum ErrorCodes {
  NETWORK_CONNECTION_ERROR = 'network-connection-error',
  GENERAL_ERROR = 'general-error',
}
